import { render } from "./MovieRating.vue?vue&type=template&id=2c35a6f7&ts=true"
import script from "./MovieRating.vue?vue&type=script&lang=ts"
export * from "./MovieRating.vue?vue&type=script&lang=ts"

import "./MovieRating.vue?vue&type=style&index=0&id=2c35a6f7&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__